import { Component, OnInit, Input } from '@angular/core';

import { WP_NOTICIAS_BASE } from 'app/config';

@Component({
  selector: 'bloco-noticia',
  templateUrl: './bloco-noticia.component.html',
  styleUrls: ['./bloco-noticia.component.scss'],
})
export class BlocoNoticiaComponent implements OnInit {

  @Input() noticia;
  routerNoticias: string = null;

  // TODO: implementar escolha automática de melhor tamanho do featured media

  ngOnInit() {
    this.routerNoticias = `/${WP_NOTICIAS_BASE}`;
  }
}
